import React from 'react';

import LoginPopup from './LoginPopup';
import RegisterPopup from './RegisterPopup';
import ForgotPasswordPopup from './ForgotPasswordPopup';

const PopupModal = ({ activePopup, handlePopupClose, handlePopupOpen }) => {
    const modalProps = {
        login: {
            component: LoginPopup,
            onClose: handlePopupClose,
            onRegister: () => {
                handlePopupClose();
                handlePopupOpen("register");
            },
            onForgotPassword: () => {
                handlePopupClose();
                handlePopupOpen("forgotPassword");
            },
        },
        register: {
            component: RegisterPopup,
            onClose: handlePopupClose,
            onLogin: () => {
                handlePopupClose();
                handlePopupOpen("login");
            },
        },
        forgotPassword: {
            component: ForgotPasswordPopup,
            onClose: handlePopupClose,
            onRegister: () => {
                handlePopupClose();
                handlePopupOpen("register");
            },
        },
    };

    const { component: ModalComponent, ...props } = modalProps[activePopup] || {};

    return ModalComponent ? <ModalComponent {...props} /> : null;
};

export default PopupModal;
